import { render, staticRenderFns } from "./vesselDet.vue?vue&type=template&id=5d781707&"
import script from "./vesselDet.vue?vue&type=script&lang=js&"
export * from "./vesselDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports